<template>
<div v-if="true" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div @click="$emit('changeVisibility')" class="fixed inset-0 dark:bg-gray-600 dark:bg-opacity-50 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <!-- removeProduct(produto.marca_id, produto.modelo_id, produto.complemento_id) -->
    <div class="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-1/2">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 group h-auto dark:bg-gray-900">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-xl leading-6 font-medium dark:text-gray-300 text-gray-900" id="modal-title">
                Finalizar recolha
            </h3>
            <span class="material-icons-outlined text-gray-600 dark:text-gray-400 text-6xl w-full text-center">
                check_circle
            </span>
            <p class="text-lg text-gray-600 dark:text-gray-400 text-center">
                Deseja finalizar recolha?
            </p>
            <p class="text-sm text-gray-600 dark:text-gray-500 text-center">
                Após finalizada você não poderar alterá-la.
            </p>
          </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-900">
        <button @click="$emit('finalizar')" type="button" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="false">
          <span>Confirmar</span>
        </button>
        <button @click="$emit('changeVisibility')" type="button" class="btn mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { reactive, ref } from '@vue/reactivity'

export default {
    name: 'PesquisadorModal',
    components: {
    },
    setup () {
        
        return {
        }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

</style>
